
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 19 16"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"d":"M6.86 6.5a9.15 9.15 0 00-3.98-.55l-.09-.88c.1-.02 2.57-.24 4.44.62l-.37.8zm-4.06.8c.14-.01 3.4-.23 5.74 1.34l-.5.74c-2.08-1.4-5.14-1.2-5.17-1.2L2.8 7.3zm-.02 2.3c.13-.01 3.3-.4 5.76 1.25l-.5.74c-2.18-1.46-5.12-1.1-5.15-1.1l-.11-.88zm.01 2.2c.13 0 3.31-.32 5.74 1.3l-.49.74C5.88 12.4 2.91 12.7 2.88 12.7l-.09-.88zM18.03 14V3.57c-2.59.08-5.12.79-7.37 2.07l-.31.18v10.56a20.67 20.67 0 017.68-2.36zM1.78 14c2.7.29 5.28 1.08 7.68 2.37V5.81l-.32-.18c-2.24-1.28-4.78-2-7.36-2.07v10.45zm16.7-11.33c.24 0 .44.2.44.44v11.3c0 .23-.18.42-.4.44l-.19.02a19.79 19.79 0 00-7.56 2.28l-.66.36-.06.02-.04.01a.43.43 0 01-.22 0l-.04-.01-.06-.02-.65-.36a19.78 19.78 0 00-7.57-2.28l-.18-.02a.44.44 0 01-.4-.44V3.11c0-.24.2-.44.44-.44 2.9 0 5.75.76 8.26 2.2l.31.17.32-.18c2.5-1.43 5.36-2.2 8.25-2.2zm-1.55 3.28c-.03 0-2.33-.21-3.98.55l-.37-.8A9.92 9.92 0 0117 5.06l-.08.88zm0 2.23c-.02 0-3.09-.2-5.16 1.2l-.5-.74C13.6 7.07 16.87 7.29 17 7.3l-.06.88zm-5.66 2.67c2.46-1.65 5.62-1.26 5.76-1.24l-.12.88c-.03 0-2.97-.36-5.14 1.1l-.5-.74zm0 2.25c2.43-1.62 5.61-1.3 5.74-1.3l-.09.9c-.03-.01-3-.3-5.16 1.14l-.49-.74z","id":"read2-a"}})]),_c('g',{attrs:{"transform":"translate(0 -2)","fill":"none","fill-rule":"evenodd"}},[_c('mask',{attrs:{"id":"read2-b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#read2-a"}})]),_c('use',{attrs:{"fill":"#020303","xlink:href":"#read2-a"}}),_c('g',{attrs:{"mask":"url(#read2-b)","fill":"#000"}},[_c('path',{attrs:{"d":"M0 0h20v19H0z"}})])])])
          )
        }
      }
    